import PropTypes from 'prop-types';

/** Centered message + one action, used when a search or filter returns nothing. */
const EmptyMessage = ({ title, hint, actionLabel, onAction }) => (
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-md-6 text-center">
        <h4 className="text-muted">{title}</h4>
        <p className="text-muted">{hint}</p>
        <button type="button" className="btn btn-primary mt-2" onClick={onAction}>
          {actionLabel}
        </button>
      </div>
    </div>
  </div>
);

EmptyMessage.propTypes = {
  title: PropTypes.node.isRequired,
  hint: PropTypes.node.isRequired,
  actionLabel: PropTypes.string.isRequired,
  onAction: PropTypes.func.isRequired,
};

export const NoSearchResults = ({ searchTerm, onShowAll }) => (
  <EmptyMessage
    title={<>No deals found for &ldquo;{searchTerm}&rdquo;</>}
    hint="Try different keywords or browse all deals."
    actionLabel="Show All Deals"
    onAction={onShowAll}
  />
);

NoSearchResults.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  onShowAll: PropTypes.func.isRequired,
};

export const NoFilterResults = ({ onClearFilters }) => (
  <EmptyMessage
    title="No deals match these filters right now"
    hint="Try another category or remove a filter."
    actionLabel="Clear filters"
    onAction={onClearFilters}
  />
);

NoFilterResults.propTypes = {
  onClearFilters: PropTypes.func.isRequired,
};
